module.exports = __webpack_public_path__ + "img/bills-payment.436aad94.svg";